import React, { useState } from 'react';
import { Field } from 'react-final-form';
import { translate } from 'react-translate-component';
import { is } from 'ramda';

import { EXCLUDE_FILE_TYPES, MAX_FILE_SIZE } from 'constants/events';

import FileInput from 'components/common/form/FileInput';

const required = (value) => !value ? translate('errors.required') : undefined;
const maxSize = (value, ref) => {
    let error = undefined;
    const maxFileSize = ref ? ref.getMaxFileSize() : MAX_FILE_SIZE;

    if (value) {
        (is(Array, value) ? value : [value]).forEach(value => {
            if (value.size > maxFileSize && !error) {
                error = translate('errors.exceededAllowedSize', { size: ref ? ref.getMaxFileSizeMB() : 32 });
            }
        });
    }

    return error;
};

const types = (value) => {
    if (!value) {
        return;
    }

    const { fileType } = value;
    return EXCLUDE_FILE_TYPES.includes(fileType) ? translate('errors.wrongFiletype', { fileType }) : undefined;
};

export default function FileUploader({ name = 'result.file', documentType, multiple, required : isRequired }) {
    const [ref, setRef] = useState(null);

    return (
        <div className='file-upload'>
            <Field
                getRef={node => setRef(node)}
                documentType={documentType}
                name={name}
                component={FileInput}
                placeholder='placeholders.freeResult'
                validate={value => (isRequired ? required(value) : undefined) || maxSize(value, ref) || types(value) }
                multipleDocuments={multiple}
            />
        </div>
    );
}
